import {
  Unit_instanceat14thlj150z as Unit_instance,
  Enum3alwj03lh1n41 as Enum,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  Long2qws0ah9gnpki as Long,
  numberToLong1a4cndvg6c52s as numberToLong,
  IllegalStateExceptionkoljg5n0nrlr as IllegalStateException,
  toString1pkumu07cwy4m as toString,
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  VOID7hggqo3abtya as VOID,
  DurationUnit_MILLISECONDS_getInstancedq9xrzm1t8sm as DurationUnit_MILLISECONDS_getInstance,
  toDuration28gf6ughsr3vf as toDuration,
  compareTo3ankvs086tmwq as compareTo,
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
  getNumberHashCode2l4nbdcihl25f as getNumberHashCode,
  equals2au1ep9vhcato as equals,
  Comparable198qfk8pnblz0 as Comparable,
  round2mrvepag8eey0 as round,
  DurationUnit_SECONDS_getInstance162tnxlnf2fpv as DurationUnit_SECONDS_getInstance,
  Companion_getInstance148flmv2wtrla as Companion_getInstance,
  initMetadataForInterface1egvbzx539z91 as initMetadataForInterface,
  _Duration___get_inWholeNanoseconds__impl__r5x4mr3elpl3cwdan58 as _Duration___get_inWholeNanoseconds__impl__r5x4mr,
  DurationUnit_NANOSECONDS_getInstance2sujg77gnqrxb as DurationUnit_NANOSECONDS_getInstance,
  toDurationba1nlt78o6vu as toDuration_0,
  fillArrayVali8eppxapiek4 as fillArrayVal,
  lazy2hsh8ze7j6ikd as lazy,
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
  numberToInt1ygmcfwhs2fkq as numberToInt,
  KProperty1ca4yb4wlo496 as KProperty1,
  getPropertyCallableRef1ajb9in178r5r as getPropertyCallableRef,
  DurationUnit_MINUTES_getInstance33ilufdckt9os as DurationUnit_MINUTES_getInstance,
  protoOf180f3jzyo7rfj as protoOf,
} from './kotlin-kotlin-stdlib.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
class DatePart extends Enum {}
class Companion {
  constructor() {
    Companion_instance = this;
    this.d1y_1 = new Long(1, 0);
    this.e1y_1 = _DateTime___init__impl__ifgty2(0.0);
    this.f1y_1 = 6.21355968E13;
  }
  g1y(unix) {
    return _DateTime___init__impl__ifgty2(unix);
  }
  h1y(unix) {
    return this.g1y(unix.r4());
  }
  i1y() {
    return _DateTime___init__impl__ifgty2(get_CoreTime().j1y());
  }
  k1y() {
    return numberToLong(get_CoreTime().j1y());
  }
  l1y(millis, part) {
    var totalDays = toInt2(millis / 86400000);
    var year = CoreTimeInternal_getInstance().c1z(totalDays);
    if (part.equals(DatePart_Year_getInstance()))
      return year;
    var isLeap = CoreTimeInternal_getInstance().d1z(year);
    var startYearDays = CoreTimeInternal_getInstance().e1z(year);
    var dayOfYear = 1 + umod(totalDays - startYearDays | 0, CoreTimeInternal_getInstance().f1z(year)) | 0;
    if (part.equals(DatePart_DayOfYear_getInstance()))
      return dayOfYear;
    // Inline function 'kotlin.takeIf' call
    var this_0 = CoreTimeInternal_getInstance().g1z(dayOfYear, isLeap);
    // Inline function 'kotlin.contracts.contract' call
    var tmp;
    // Inline function 'korlibs.time.Companion.getDatePart.<anonymous>' call
    if (this_0 >= 0) {
      tmp = this_0;
    } else {
      tmp = null;
    }
    var tmp0_elvis_lhs = tmp;
    var tmp_0;
    if (tmp0_elvis_lhs == null) {
      var message = 'Invalid dayOfYear=' + dayOfYear + ', isLeap=' + isLeap;
      throw IllegalStateException.l5(toString(message));
    } else {
      tmp_0 = tmp0_elvis_lhs;
    }
    var month = tmp_0;
    if (part.equals(DatePart_Month_getInstance()))
      return month;
    var dayOfMonth = dayOfYear - CoreTimeInternal_getInstance().h1z(month, isLeap) | 0;
    if (part.equals(DatePart_Day_getInstance()))
      return dayOfMonth;
    // Inline function 'kotlin.error' call
    var message_0 = 'Invalid DATE_PART';
    throw IllegalStateException.l5(toString(message_0));
  }
}
class DateTime {
  constructor(unixMillis) {
    Companion_getInstance_0();
    this.i1z_1 = unixMillis;
  }
  j1z(other) {
    return DateTime__compareTo_impl_geo3bs(this.i1z_1, other);
  }
  d(other) {
    return DateTime__compareTo_impl_geo3bs_0(this, other);
  }
  toString() {
    return DateTime__toString_impl_cnueje(this.i1z_1);
  }
  hashCode() {
    return DateTime__hashCode_impl_yf0bc9(this.i1z_1);
  }
  equals(other) {
    return DateTime__equals_impl_qd7s8j(this.i1z_1, other);
  }
}
class Companion_0 {
  k1z() {
    return _FastDuration___init__impl__cfl6bz(0.0);
  }
  l1z() {
    return _FastDuration___init__impl__cfl6bz(NaN);
  }
  m1z() {
    return this.l1z();
  }
}
class FastDuration {
  constructor(ms) {
    this.n1z_1 = ms;
  }
  o1z(other) {
    return FastDuration__compareTo_impl_4fhnj7(this.n1z_1, other);
  }
  d(other) {
    return FastDuration__compareTo_impl_4fhnj7_0(this, other);
  }
  toString() {
    return FastDuration__toString_impl_c9xohb(this.n1z_1);
  }
  hashCode() {
    return FastDuration__hashCode_impl_y13la6(this.n1z_1);
  }
  equals(other) {
    return FastDuration__equals_impl_unk8ke(this.n1z_1, other);
  }
}
class TimeProvider {}
class Companion_1 {
  i1y() {
    return Companion_getInstance_0().i1y();
  }
}
class ICoreTime {}
function performanceMillis() {
  return this.j1y();
}
class CoreTimeInternal {
  constructor() {
    CoreTimeInternal_instance = this;
    this.m1y_1 = 1000;
    this.n1y_1 = 60000;
    this.o1y_1 = 3600000;
    this.p1y_1 = 86400000;
    this.q1y_1 = 604800000;
    this.r1y_1 = 0.001;
    this.s1y_1 = 1.0E-6;
    var tmp = this;
    tmp.t1y_1 = lazy(CoreTimeInternal$MONTH_START_DAYS$delegate$lambda);
    this.u1y_1 = 365;
    this.v1y_1 = 366;
    this.w1y_1 = 1;
    this.x1y_1 = 24;
    this.y1y_1 = 97;
    this.z1y_1 = 1461;
    this.a1z_1 = 36524;
    this.b1z_1 = 146097;
  }
  s1z() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.t1y_1;
    MONTH_START_DAYS$factory();
    return this_0.u1();
  }
  h1z(month, leap) {
    return this.s1z()[leap ? 1 : 0][this.t1z(month) - 1 | 0];
  }
  t1z(month) {
    return ((month - 1 | 0) % 12 | 0) + 1 | 0;
  }
  r1z(month, leap) {
    switch (this.t1z(month)) {
      case 1:
      case 3:
      case 5:
      case 7:
      case 8:
      case 10:
      case 12:
        return 31;
      case 2:
        return leap ? 29 : 28;
      default:
        return 30;
    }
  }
  g1z(dayOfYear, leap) {
    var days = this.s1z()[leap ? 1 : 0];
    var day0 = dayOfYear - 1 | 0;
    var guess = day0 / 32 | 0;
    var tmp;
    if (0 <= guess ? guess <= 11 : false) {
      var containsLower = days[guess];
      tmp = day0 < days[guess + 1 | 0] ? containsLower <= day0 : false;
    } else {
      tmp = false;
    }
    if (tmp)
      return guess + 1 | 0;
    var tmp_0;
    if (0 <= guess ? guess <= 10 : false) {
      var containsLower_0 = days[guess + 1 | 0];
      tmp_0 = day0 < days[guess + 2 | 0] ? containsLower_0 <= day0 : false;
    } else {
      tmp_0 = false;
    }
    if (tmp_0)
      return guess + 2 | 0;
    return -1;
  }
  d1z(year) {
    return (year % 4 | 0) === 0 && (!((year % 100 | 0) === 0) || (year % 400 | 0) === 0);
  }
  e1z(year) {
    return imul(365, year - 1 | 0) + this.u1z(year) | 0;
  }
  f1z(year) {
    return this.v1z(this.d1z(year));
  }
  v1z(leap) {
    return leap ? 366 : 365;
  }
  u1z(year) {
    if (year < 1) {
      var leapCount = 0;
      var y = 1;
      while (y >= year) {
        if (this.d1z(y)) {
          leapCount = leapCount - 1 | 0;
        }
        y = y - 1 | 0;
      }
      return leapCount;
    }
    var y1 = year - 1 | 0;
    var res = ((y1 / 4 | 0) - (y1 / 100 | 0) | 0) + (y1 / 400 | 0) | 0;
    return res;
  }
  c1z(days) {
    var v400 = days / 146097 | 0;
    var r400 = days - imul(v400, 146097) | 0;
    // Inline function 'kotlin.math.min' call
    var a = r400 / 36524 | 0;
    var v100 = Math.min(a, 3);
    var r100 = r400 - imul(v100, 36524) | 0;
    var v4 = r100 / 1461 | 0;
    var r4 = r100 - imul(v4, 1461) | 0;
    // Inline function 'kotlin.math.min' call
    var a_0 = r4 / 365 | 0;
    var v1 = Math.min(a_0, 3);
    var extra = days < 0 ? 0 : 1;
    return (((extra + v1 | 0) + imul(v4, 4) | 0) + imul(v100, 100) | 0) + imul(v400, 400) | 0;
  }
}
class CoreTime$1 {
  j1y() {
    return Date.now();
  }
  q1z(time) {
    // Inline function 'korlibs.time.minutes' call
    // Inline function 'korlibs.time.minutes' call
    var this_0 = (new Date(time.r4())).getTimezoneOffset();
    return toDuration(this_0, DurationUnit_MINUTES_getInstance());
  }
}
//endregion
var DatePart_Year_instance;
var DatePart_DayOfYear_instance;
var DatePart_Month_instance;
var DatePart_Day_instance;
var DatePart_entriesInitialized;
function DatePart_initEntries() {
  if (DatePart_entriesInitialized)
    return Unit_instance;
  DatePart_entriesInitialized = true;
  DatePart_Year_instance = new DatePart('Year', 0);
  DatePart_DayOfYear_instance = new DatePart('DayOfYear', 1);
  DatePart_Month_instance = new DatePart('Month', 2);
  DatePart_Day_instance = new DatePart('Day', 3);
}
function DatePart_Year_getInstance() {
  DatePart_initEntries();
  return DatePart_Year_instance;
}
function DatePart_DayOfYear_getInstance() {
  DatePart_initEntries();
  return DatePart_DayOfYear_instance;
}
function DatePart_Month_getInstance() {
  DatePart_initEntries();
  return DatePart_Month_instance;
}
function DatePart_Day_getInstance() {
  DatePart_initEntries();
  return DatePart_Day_instance;
}
function _DateTime___init__impl__ifgty2(unixMillis) {
  return unixMillis;
}
function _DateTime___get_unixMillis__impl__ofxkzp($this) {
  return $this;
}
var Companion_instance;
function Companion_getInstance_0() {
  if (Companion_instance === VOID)
    new Companion();
  return Companion_instance;
}
function _DateTime___get_yearOneMillis__impl__jjnslg($this) {
  return 6.21355968E13 + _DateTime___get_unixMillis__impl__ofxkzp($this);
}
function _DateTime___get_unixMillisDouble__impl__3dzlsc($this) {
  return _DateTime___get_unixMillis__impl__ofxkzp($this);
}
function _DateTime___get_unixMillisLong__impl__sdx9bd($this) {
  return numberToLong(_DateTime___get_unixMillisDouble__impl__3dzlsc($this));
}
function _DateTime___get_yearInt__impl__876eh3($this) {
  return Companion_getInstance_0().l1y(_DateTime___get_yearOneMillis__impl__jjnslg($this), DatePart_Year_getInstance());
}
function _DateTime___get_month1__impl__hf8ase($this) {
  return Companion_getInstance_0().l1y(_DateTime___get_yearOneMillis__impl__jjnslg($this), DatePart_Month_getInstance());
}
function _DateTime___get_dayOfMonth__impl__z5062($this) {
  return Companion_getInstance_0().l1y(_DateTime___get_yearOneMillis__impl__jjnslg($this), DatePart_Day_getInstance());
}
function _DateTime___get_hours__impl__gihczo($this) {
  return toIntMod(_DateTime___get_yearOneMillis__impl__jjnslg($this) / 3600000, 24);
}
function _DateTime___get_minutes__impl__ua9590($this) {
  return toIntMod(_DateTime___get_yearOneMillis__impl__jjnslg($this) / 60000, 60);
}
function DateTime__plus_impl_5iyako($this, delta) {
  return _DateTime___init__impl__ifgty2(_DateTime___get_unixMillis__impl__ofxkzp($this) + get_milliseconds(delta));
}
function DateTime__minus_impl_10njw8($this, delta) {
  return _DateTime___init__impl__ifgty2(_DateTime___get_unixMillis__impl__ofxkzp($this) - get_milliseconds(delta));
}
function DateTime__minus_impl_10njw8_0($this, other) {
  // Inline function 'korlibs.time.milliseconds' call
  var this_0 = _DateTime___get_unixMillisDouble__impl__3dzlsc($this) - _DateTime___get_unixMillisDouble__impl__3dzlsc(other);
  return toDuration(this_0, DurationUnit_MILLISECONDS_getInstance());
}
function DateTime__compareTo_impl_geo3bs($this, other) {
  return compareTo(_DateTime___get_unixMillis__impl__ofxkzp($this), _DateTime___get_unixMillis__impl__ofxkzp(other));
}
function DateTime__compareTo_impl_geo3bs_0($this, other) {
  return DateTime__compareTo_impl_geo3bs($this.i1z_1, other instanceof DateTime ? other.i1z_1 : THROW_CCE());
}
function DateTime__toString_impl_cnueje($this) {
  return 'DateTime(' + _DateTime___get_unixMillisLong__impl__sdx9bd($this).toString() + ')';
}
function DateTime__hashCode_impl_yf0bc9($this) {
  return getNumberHashCode($this);
}
function DateTime__equals_impl_qd7s8j($this, other) {
  if (!(other instanceof DateTime))
    return false;
  var tmp0_other_with_cast = other instanceof DateTime ? other.i1z_1 : THROW_CCE();
  if (!equals($this, tmp0_other_with_cast))
    return false;
  return true;
}
function _FastDuration___init__impl__cfl6bz(ms) {
  return ms;
}
function _get_ms__ndc6g5($this) {
  return $this;
}
var Companion_instance_0;
function Companion_getInstance_1() {
  return Companion_instance_0;
}
function _FastDuration___get_isNil__impl__n4fw9d($this) {
  return equals($this, Companion_instance_0.m1z());
}
function _FastDuration___get_seconds__impl__4kvvav($this) {
  return _get_ms__ndc6g5($this) / 1000;
}
function _FastDuration___get_milliseconds__impl__ffr17u($this) {
  return _get_ms__ndc6g5($this);
}
function _FastDuration___get_microseconds__impl__o4j93h($this) {
  return _get_ms__ndc6g5($this) * 1000;
}
function _FastDuration___get_nanoseconds__impl__pxizcb($this) {
  return _get_ms__ndc6g5($this) * 1000000;
}
function _FastDuration___get_fastMilliseconds__impl__pe68va($this) {
  return _FastDuration___get_milliseconds__impl__ffr17u($this);
}
function _FastDuration___get_fastMicroseconds__impl__e641g1($this) {
  return _FastDuration___get_microseconds__impl__o4j93h($this);
}
function _FastDuration___get_fastNanoseconds__impl__9kjwbr($this) {
  return _FastDuration___get_nanoseconds__impl__pxizcb($this);
}
function FastDuration__plus_impl_q1enab($this, that) {
  return _FastDuration___init__impl__cfl6bz(_get_ms__ndc6g5($this) + _get_ms__ndc6g5(that));
}
function FastDuration__minus_impl_evs237($this, that) {
  return _FastDuration___init__impl__cfl6bz(_get_ms__ndc6g5($this) - _get_ms__ndc6g5(that));
}
function FastDuration__div_impl_rlslck($this, other) {
  return _get_ms__ndc6g5($this) / _get_ms__ndc6g5(other);
}
function FastDuration__times_impl_h6amcp($this, scale) {
  return _FastDuration___init__impl__cfl6bz(_get_ms__ndc6g5($this) * scale);
}
function FastDuration__div_impl_rlslck_0($this, scale) {
  return _FastDuration___init__impl__cfl6bz(_get_ms__ndc6g5($this) / scale);
}
function FastDuration__plus_impl_q1enab_0($this, other) {
  return _FastDuration___init__impl__cfl6bz(_FastDuration___get_milliseconds__impl__ffr17u($this) + get_milliseconds(other));
}
function FastDuration__minus_impl_evs237_0($this, other) {
  return _FastDuration___init__impl__cfl6bz(_FastDuration___get_milliseconds__impl__ffr17u($this) - get_milliseconds(other));
}
function FastDuration__compareTo_impl_4fhnj7($this, other) {
  return compareTo(_get_ms__ndc6g5($this), _get_ms__ndc6g5(other));
}
function FastDuration__compareTo_impl_4fhnj7_0($this, other) {
  return FastDuration__compareTo_impl_4fhnj7($this.n1z_1, other instanceof FastDuration ? other.n1z_1 : THROW_CCE());
}
function FastDuration__compareTo_impl_4fhnj7_1($this, other) {
  return compareTo(_get_ms__ndc6g5($this), get_milliseconds(other));
}
function FastDuration__toString_impl_c9xohb($this) {
  return 'FastDuration(ms=' + $this + ')';
}
function FastDuration__hashCode_impl_y13la6($this) {
  return getNumberHashCode($this);
}
function FastDuration__equals_impl_unk8ke($this, other) {
  if (!(other instanceof FastDuration))
    return false;
  var tmp0_other_with_cast = other instanceof FastDuration ? other.n1z_1 : THROW_CCE();
  if (!equals($this, tmp0_other_with_cast))
    return false;
  return true;
}
function get_fastSeconds(_this__u8e3s4) {
  return get_fastSeconds_0(_this__u8e3s4);
}
function toDuration_1(_this__u8e3s4) {
  return get_slow(_this__u8e3s4);
}
function get_fast(_this__u8e3s4) {
  var tmp;
  // Inline function 'korlibs.time.isNil' call
  if (equals(_this__u8e3s4, get_DURATION_NIL())) {
    tmp = Companion_instance_0.m1z();
  } else {
    tmp = get_fastMilliseconds_0(get_milliseconds(_this__u8e3s4));
  }
  return tmp;
}
function get_fastMicroseconds(_this__u8e3s4) {
  return _FastDuration___init__impl__cfl6bz(_this__u8e3s4 / 1000);
}
function minus(_this__u8e3s4, other) {
  return _FastDuration___init__impl__cfl6bz(get_milliseconds(_this__u8e3s4) - _FastDuration___get_milliseconds__impl__ffr17u(other));
}
function get_fastMilliseconds(_this__u8e3s4) {
  return get_fastMilliseconds_0(_this__u8e3s4);
}
function roundMilliseconds(_this__u8e3s4) {
  return get_fastMilliseconds_0(round(_FastDuration___get_milliseconds__impl__ffr17u(_this__u8e3s4)));
}
function get_slow(_this__u8e3s4) {
  var tmp;
  if (_FastDuration___get_isNil__impl__n4fw9d(_this__u8e3s4)) {
    // Inline function 'korlibs.time.NIL' call
    Companion_getInstance();
    tmp = get_DURATION_NIL();
  } else {
    // Inline function 'korlibs.time.seconds' call
    var this_0 = _FastDuration___get_seconds__impl__4kvvav(_this__u8e3s4);
    tmp = toDuration(this_0, DurationUnit_SECONDS_getInstance());
  }
  return tmp;
}
function get_fastMilliseconds_0(_this__u8e3s4) {
  return _FastDuration___init__impl__cfl6bz(_this__u8e3s4);
}
function get_fastSeconds_0(_this__u8e3s4) {
  return _FastDuration___init__impl__cfl6bz(_this__u8e3s4 * 1000);
}
function get_fastMicroseconds_0(_this__u8e3s4) {
  return get_fastMilliseconds_0(_this__u8e3s4);
}
function div(_this__u8e3s4, other) {
  return get_milliseconds(_this__u8e3s4) / _FastDuration___get_milliseconds__impl__ffr17u(other);
}
function get_fastNanoseconds(_this__u8e3s4) {
  return _FastDuration___init__impl__cfl6bz(_this__u8e3s4 / 1000000);
}
function compareTo_0(_this__u8e3s4, other) {
  return compareTo(get_milliseconds(_this__u8e3s4), _FastDuration___get_milliseconds__impl__ffr17u(other));
}
function get_fastNanoseconds_0(_this__u8e3s4) {
  return get_fastMilliseconds_0(_this__u8e3s4);
}
var Companion_instance_1;
function Companion_getInstance_2() {
  return Companion_instance_1;
}
function get_DURATION_NIL() {
  _init_properties_TimeSpan_kt__xworpz();
  return DURATION_NIL;
}
var DURATION_NIL;
function get_milliseconds(_this__u8e3s4) {
  _init_properties_TimeSpan_kt__xworpz();
  return _Duration___get_inWholeNanoseconds__impl__r5x4mr(_this__u8e3s4).r4() / 1000000.0;
}
function get_seconds(_this__u8e3s4) {
  _init_properties_TimeSpan_kt__xworpz();
  return get_milliseconds(_this__u8e3s4) / 1000;
}
function max(a, b) {
  _init_properties_TimeSpan_kt__xworpz();
  // Inline function 'kotlin.time.Companion.milliseconds' call
  Companion_getInstance();
  // Inline function 'kotlin.math.max' call
  var a_0 = get_milliseconds(a);
  var b_0 = get_milliseconds(b);
  var this_0 = Math.max(a_0, b_0);
  return toDuration(this_0, DurationUnit_MILLISECONDS_getInstance());
}
var properties_initialized_TimeSpan_kt_fytdnd;
function _init_properties_TimeSpan_kt__xworpz() {
  if (!properties_initialized_TimeSpan_kt_fytdnd) {
    properties_initialized_TimeSpan_kt_fytdnd = true;
    DURATION_NIL = toDuration_0(new Long(13, -2097152), DurationUnit_NANOSECONDS_getInstance());
  }
}
function CoreTimeInternal$MONTH_START_DAYS$delegate$lambda() {
  var tmp = 0;
  // Inline function 'kotlin.arrayOfNulls' call
  var tmp_0 = fillArrayVal(Array(2), null);
  while (tmp < 2) {
    var tmp_1 = tmp;
    var acc = {_v: 0};
    var tmp_2 = 0;
    var tmp_3 = new Int32Array(13);
    while (tmp_2 < 13) {
      var tmp_4 = tmp_2;
      acc._v = acc._v + (tmp_4 === 0 ? 0 : CoreTimeInternal_getInstance().r1z(tmp_4, !(tmp_1 === 0))) | 0;
      tmp_3[tmp_4] = acc._v;
      tmp_2 = tmp_2 + 1 | 0;
    }
    tmp_0[tmp_1] = tmp_3;
    tmp = tmp + 1 | 0;
  }
  return tmp_0;
}
var CoreTimeInternal_instance;
function CoreTimeInternal_getInstance() {
  if (CoreTimeInternal_instance === VOID)
    new CoreTimeInternal();
  return CoreTimeInternal_instance;
}
function toInt2(_this__u8e3s4) {
  var tmp;
  if (_this__u8e3s4 < 0.0) {
    // Inline function 'kotlin.math.floor' call
    var tmp$ret$0 = Math.floor(_this__u8e3s4);
    tmp = numberToInt(tmp$ret$0);
  } else {
    tmp = numberToInt(_this__u8e3s4);
  }
  return tmp;
}
function umod(_this__u8e3s4, other) {
  var rm = _this__u8e3s4 % other | 0;
  var remainder = rm === 0 ? 0 : rm;
  return remainder < 0 ? remainder + other | 0 : remainder;
}
function toIntMod(_this__u8e3s4, mod) {
  return toInt2(umod_0(_this__u8e3s4, mod));
}
function umod_0(_this__u8e3s4, other) {
  var rm = _this__u8e3s4 % other;
  var remainder = rm === -0.0 ? 0.0 : rm;
  return remainder < 0.0 ? remainder + other : remainder;
}
function MONTH_START_DAYS$factory() {
  return getPropertyCallableRef('MONTH_START_DAYS', 1, KProperty1, function (receiver) {
    return receiver.s1z();
  }, null);
}
function get_CoreTime() {
  _init_properties_CoreTime_js_kt__zee7g9();
  return CoreTime;
}
var CoreTime;
var properties_initialized_CoreTime_js_kt_73dge3;
function _init_properties_CoreTime_js_kt__zee7g9() {
  if (!properties_initialized_CoreTime_js_kt_73dge3) {
    properties_initialized_CoreTime_js_kt_73dge3 = true;
    CoreTime = new CoreTime$1();
  }
}
//region block: post-declaration
initMetadataForClass(DatePart, 'DatePart');
initMetadataForCompanion(Companion);
initMetadataForClass(DateTime, 'DateTime', VOID, VOID, [Comparable]);
initMetadataForCompanion(Companion_0);
initMetadataForClass(FastDuration, 'FastDuration', VOID, VOID, [Comparable]);
initMetadataForInterface(TimeProvider, 'TimeProvider');
initMetadataForCompanion(Companion_1, VOID, [TimeProvider]);
initMetadataForInterface(ICoreTime, 'ICoreTime');
initMetadataForObject(CoreTimeInternal, 'CoreTimeInternal');
protoOf(CoreTime$1).p1z = performanceMillis;
initMetadataForClass(CoreTime$1, VOID, VOID, VOID, [ICoreTime]);
//endregion
//region block: init
Companion_instance_0 = new Companion_0();
Companion_instance_1 = new Companion_1();
//endregion
//region block: exports
export {
  _DateTime___init__impl__ifgty2 as _DateTime___init__impl__ifgty21fo6nvrmtb6p2,
  _DateTime___get_dayOfMonth__impl__z5062 as _DateTime___get_dayOfMonth__impl__z506256cd6wamh0kw,
  DateTime__hashCode_impl_yf0bc9 as DateTime__hashCode_impl_yf0bc92s64omsn0fynv,
  _DateTime___get_hours__impl__gihczo as _DateTime___get_hours__impl__gihczo35ytaabq3gkeo,
  DateTime__minus_impl_10njw8_0 as DateTime__minus_impl_10njw812puhhvc4b9kf,
  DateTime__minus_impl_10njw8 as DateTime__minus_impl_10njw81qwhaqtma3616,
  _DateTime___get_minutes__impl__ua9590 as _DateTime___get_minutes__impl__ua95902l29qjvguq6w4,
  _DateTime___get_month1__impl__hf8ase as _DateTime___get_month1__impl__hf8asee126f1eezywk,
  DateTime__plus_impl_5iyako as DateTime__plus_impl_5iyako1s2vd5845gpbb,
  DateTime__toString_impl_cnueje as DateTime__toString_impl_cnueje2ackcuvowzg0n,
  _DateTime___get_unixMillis__impl__ofxkzp as _DateTime___get_unixMillis__impl__ofxkzpm42fln1madjv,
  _DateTime___get_unixMillisDouble__impl__3dzlsc as _DateTime___get_unixMillisDouble__impl__3dzlscv2y7jxuwezuj,
  _DateTime___get_unixMillisLong__impl__sdx9bd as _DateTime___get_unixMillisLong__impl__sdx9bd2a9o7fvoi9ybx,
  _DateTime___get_yearInt__impl__876eh3 as _DateTime___get_yearInt__impl__876eh31suupdzruerzf,
  FastDuration__compareTo_impl_4fhnj7 as FastDuration__compareTo_impl_4fhnj72c084ut3ho50d,
  FastDuration__compareTo_impl_4fhnj7_1 as FastDuration__compareTo_impl_4fhnj73optjj2wg605h,
  FastDuration__div_impl_rlslck as FastDuration__div_impl_rlslck3eqcfgtjve915,
  FastDuration__div_impl_rlslck_0 as FastDuration__div_impl_rlslck2moqkr2wlhp55,
  _FastDuration___get_fastMicroseconds__impl__e641g1 as _FastDuration___get_fastMicroseconds__impl__e641g11wrcl3xo4cr7g,
  _FastDuration___get_fastMilliseconds__impl__pe68va as _FastDuration___get_fastMilliseconds__impl__pe68va81p5t8ucvnk8,
  _FastDuration___get_fastNanoseconds__impl__9kjwbr as _FastDuration___get_fastNanoseconds__impl__9kjwbr3nvm3csqkttdd,
  FastDuration__hashCode_impl_y13la6 as FastDuration__hashCode_impl_y13la6nym0c1xbwjaa,
  _FastDuration___get_microseconds__impl__o4j93h as _FastDuration___get_microseconds__impl__o4j93h2rn63lkq7a8kl,
  _FastDuration___get_milliseconds__impl__ffr17u as _FastDuration___get_milliseconds__impl__ffr17unfwkaxi4cy42,
  FastDuration__minus_impl_evs237_0 as FastDuration__minus_impl_evs237bt7zqxxnwet,
  FastDuration__minus_impl_evs237 as FastDuration__minus_impl_evs237rhg84spop2c8,
  _FastDuration___get_nanoseconds__impl__pxizcb as _FastDuration___get_nanoseconds__impl__pxizcb1ry8wyoc0dr5c,
  FastDuration__plus_impl_q1enab as FastDuration__plus_impl_q1enab1plpz0e6mgxzj,
  FastDuration__plus_impl_q1enab_0 as FastDuration__plus_impl_q1enab30y5opwsu5po5,
  _FastDuration___get_seconds__impl__4kvvav as _FastDuration___get_seconds__impl__4kvvavkn2srn5t4e0w,
  FastDuration__times_impl_h6amcp as FastDuration__times_impl_h6amcp3u6kv4tju4mnx,
  FastDuration__toString_impl_c9xohb as FastDuration__toString_impl_c9xohb3u75ye94mx1dw,
  Companion_getInstance_0 as Companion_getInstance36wz4kh9aujgq,
  Companion_instance_0 as Companion_instance293l0r179rei7,
  Companion_instance_1 as Companion_instance3gshkh79a96f7,
  get_CoreTime as get_CoreTime23yr4od90u6o9,
  get_DURATION_NIL as get_DURATION_NIL2lkiawowwp1us,
  DateTime as DateTime2gld4ho36azq9,
  FastDuration as FastDuration3d3pupg2e5ora,
  TimeProvider as TimeProvider2j6wl2le6n0p3,
  compareTo_0 as compareTo2tbidk88xyn1w,
  div as div1s6t4x2ts64sh,
  get_fast as get_fast37cu8s8qwnuyi,
  get_fastMicroseconds_0 as get_fastMicroseconds16wth98xujxdo,
  get_fastMicroseconds as get_fastMicroseconds3xewe49ldi5s,
  get_fastMilliseconds as get_fastMilliseconds2pmoifl74b2oz,
  get_fastMilliseconds_0 as get_fastMillisecondsfxaeyfzoedsj,
  get_fastNanoseconds_0 as get_fastNanoseconds1laeiegsk8vcx,
  get_fastNanoseconds as get_fastNanosecondsibv7lnrlu50o,
  get_fastSeconds as get_fastSecondsxsf72e0ltu4j,
  max as max1q2oylvn6uire,
  get_milliseconds as get_milliseconds20vru1dkca6bq,
  minus as minus2npwq73u0d9yx,
  roundMilliseconds as roundMilliseconds3bd2pntxev66o,
  get_seconds as get_secondsjblpw5qd4dzj,
  get_slow as get_slowaqovrrnrezzv,
  toDuration_1 as toDuration15w5sljvx2ut2,
};
//endregion
